import { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { ComponentsOverview } from '../ComponentsOverview';
import { PointsOfInterest } from '../PointsOfInterest';
import { BasicTabs } from '@/components/shared/BasicTabs';
import { FloatingLine, tabStyles } from './styles';

const tabs = [
  { label: 'Component overview', component: <ComponentsOverview /> },
  { label: 'Points of Interest', component: <PointsOfInterest /> },
].map((tab, index) => ({
  ...tab,
  index,
}));

export const TabNavigation = () => {
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (!selectedAssemblyId) {
      setSelectedTab(0);
    }
  }, [selectedAssemblyId]);

  return (
    <BasicTabs
      tabs={tabs}
      selectedTab={selectedTab}
      changeTab={setSelectedTab}
      tabsStyles={tabStyles}
      customSeperator={<FloatingLine />}
    />
  );
};
